import { Injectable, ViewContainerRef } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { DialogService } from './dialog.service';
import { AuthService } from './auth.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<OnDeactivate> {

  constructor(private authService: AuthService) { }

  canDeactivate(component: OnDeactivate): Promise<boolean> | boolean {
    if (component.onNavigatingAway) {
      return !this.authService.loggedIn() || component.onNavigatingAway();
    }
    return true;
  }
}

export interface OnDeactivate {
  form: FormGroup;
  onNavigatingAway(): Promise<boolean> | boolean;
}
